<ng-template globalLoaderHost></ng-template>
<ng-container *ngIf="currentUser?.impersonated">
  <div class="impersonation"></div>
  <button
    mat-raised-button
    color="warn"
    class="impersonation-btn"
    (click)="removeImpersonation()"
  >
    <mat-icon class="primary-icon">person</mat-icon>
    <mat-icon class="secondary-icon">clear</mat-icon>
    {{ "IMPERSONATION.EXIT" | translate }}
  </button>
</ng-container>
<router-outlet></router-outlet>
